import { Component, OnInit,ViewEncapsulation, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { GlobalService } from '../global.service';
@Component({
  selector: 'app-formcontentchat',
  templateUrl: './formcontentchat.component.html',
  styleUrls: ['./formcontentchat.component.sass'],
  encapsulation:ViewEncapsulation.None
})
export class FormContentChatComponent implements OnInit {

  public name;
  public email;
  public firstname;
  public lastname;
  public preguntaChat;
  public idDPTOChat;
  public message;
  private path:string='https://chat3.claropr.com/webapiserver/ECSApp/ChatWidget3/ChatPanel.aspx';
  public isLogged:boolean=false;
  constructor(private global:GlobalService,public matDialogRef:MatDialogRef<FormContentChatComponent>,@Inject(MAT_DIALOG_DATA) public data: any, private router:Router) {}

  ngOnInit() {
    if(sessionStorage.getItem("session")=="false" || sessionStorage.getItem("session")==null){
      this.name='';
      this.email='';
    }
    else{
      this.name=JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).AccounInfo.firstNameField;
      this.email=JSON.parse(atob(sessionStorage.getItem("GetPersonalData"))).Email
      this.isLogged=true;
    }
      
      this.message='';
      this.idDPTOChat=15;
  }
  public close(){;
    this.matDialogRef.close('cancel');
  }
  irChat(){
    if(sessionStorage.getItem("session")!=null){
      this.global.validateSession();
    }
    if(this.validator()){
      var url = this.path+'?Email=' + this.email + '&firstname=' + this.firstname + '&lastname=' + this.lastname + '&Question=' + this.message + '&Department='+this.idDPTOChat+'';
      window.open(url, '', 'width=630, height=490,top=100,left=100');  
    }
  }
  validator(){
    var sw=true;
    if(this.name!=='' && this.name!=undefined){
      var nombre = this.name.split(' ');
      this.firstname = nombre[0];
      this.lastname='';
      if (nombre[1] === '') {
          this.lastname = nombre[2];
      }
      else {
          this.lastname = nombre[1];
      }
      if (nombre[3] !== 'undefined' && nombre[3] !== null) {
          this.lastname = this.lastname + ' ' + nombre[3];
      }
      if (this.lastname === undefined) {
        this.global.notif('Por favor, debe colocar su nombre y apellido.');
        sw=false;
      }
      else {
          if(this.email==''){
            this.global.notif('Debe colocar su correo electrónico.');
            sw=false;
          }
          else if(this.global.validarEmail(this.email)==false){
            this.global.notif('Por favor debe colocar un formato de correo electrónico válido.');
            sw=false;
          }
          else if(this.message==''){
            this.global.notif('Debe colocar una pregunta.');
            sw=false;
          }
          else{
            this.close();
          }
      }
    }
    else {
      this.global.notif('Debe colocar su nombre y apellido.');
      sw=false;
    }
    return sw;
  }
}